import * as React from 'react';
// Import react.
import { useParams } from "react-router-dom";
// Import interfaces.
import {
	ILogoutInfo,
} from '@app/interfaces';

interface UseLogoutInfoPropsFromRouterResult extends ILogoutInfo {

}

const useLogoutInfoPropsFromRouter = (): UseLogoutInfoPropsFromRouterResult => {
	const params = useParams();

	// Parse out the router parameters for command props.
	const appV2LoggedOutStr: string = React.useMemo(() => {
		return params['appV2LoggedOut'] ?? String.empty();
	}, [params]);

	const appV2LoggedOut: boolean = React.useMemo(() => {
		return appV2LoggedOutStr.toLowerCase() === true.toString() ? true : false
	}, [appV2LoggedOutStr]);

	const returnToUrl: string = React.useMemo(() => {
		return params['returnToUrl'] ?? String.empty();
	}, [params]);

	return {
		appV2LoggedOut,
		returnToUrl,
	};
}

// Export results.
export {
	UseLogoutInfoPropsFromRouterResult,
}

export default useLogoutInfoPropsFromRouter;